// @flow

import { type IncomingPayment } from './types';

export function getMustRedirectAfterPayment(incomingPayment: IncomingPayment): boolean {
  if (incomingPayment.status !== 'CO' && incomingPayment.status !== 'CA' && incomingPayment.status !== 'PE')
    throw new Error(`IncomingPayment: there is no "must_redirect_after_payment" key in a ${incomingPayment.status} payment`);

  return !!incomingPayment['must_redirect_after_payment'];
}
